export default __webpack_public_path__ + "static/media/debian.ac6aef53.svg";